// context/AppContext.js
import { createContext, useContext, useEffect, useState } from "react";
import {checkCode, fetchTheme, get_cfg} from "./api/apis";
import { setSidGetter } from "./api/srs";
import {applyTheme, useTheme} from "./util/Theme";

const AppContext = createContext();
export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children, restaurant }) => {
    const [cfg, setCfgState] = useState(null);
    const [auth, setAuthState] = useState(null);
    const [loading, setLoading] = useState(true);
    const [menu, setMenuState] = useState([]);
    const [orderids, setOrderidsState] = useState([]);
    const [unpaid, setUnpaid] = useState(false);

    const normalize = item => ({
        id: Number(item?.id ?? item),
        paid: Boolean(item?.paid ?? true)
    });

    const checkRestaurant = () => {
        if (cfg && restaurant && cfg.uid !== restaurant) {
            setCfg(null);
        }
    };

    const fetchOrderids = () => {
        const storage = JSON.parse(localStorage.getItem("orderids")) ?? {};
        const restStorage = storage[restaurant] ?? [];
        const normalized = restStorage.map(normalize);
        setOrderidsState(normalized);
    };

    const setOrderids = (list = []) => {
        const normalizedList = list
            .map(normalize)
            .filter((v, i, a) => a.findIndex(t => t.id === v.id) === i); // dedupe

        const storage = JSON.parse(localStorage.getItem("orderids")) ?? {};
        storage[restaurant] = normalizedList;
        localStorage.setItem("orderids", JSON.stringify(storage));

        setOrderidsState(normalizedList);
    };

    useEffect(() => {
        const hasUnpaid = orderids.some(item => item.paid === false);
        console.log(orderids)
        setUnpaid(hasUnpaid);
    }, [orderids]);

    useEffect(() => {
        checkRestaurant();
        fetchOrderids();
    }, [cfg, restaurant]);

    useEffect(() => {
        init();
    }, [restaurant]);

    const getMenu = menu;
    const setMenu = input => {
        setMenuState(input);
    };

    const init = async () => {
        const raw = localStorage.getItem("cfg");
        let storedCfg;
        try {
            storedCfg = raw && raw !== "undefined" ? JSON.parse(raw) : null;
        } catch {
            localStorage.removeItem("cfg");
            storedCfg = null;
        }

        const previousTable = storedCfg?.bord || "";
        const fresh = await get_cfg(restaurant);

        if (previousTable && storedCfg?.uid === fresh.uid) {
            fresh.bord = previousTable;
        }

        setCfgState(fresh);
        localStorage.setItem("cfg", JSON.stringify(fresh));

        if (fresh.sid) setSidGetter(() => fresh.sid);
        setLoading(false);
    };

    const getAuth = async () => {
        if (auth?.phone && auth?.code) {
            const response = await checkCode(auth?.phone, auth?.code);
            if (response.ok) return auth;
        }
        setAuth(null);
        return null;
    };

    const getCfg = async () => {
        if (cfg) return cfg;
        const res = await get_cfg(restaurant);
        setCfg(res);
        return res;
    };

    useEffect(() => {
        if (cfg?.sid) {
            setSidGetter(() => cfg.sid);
        }
    }, [cfg]);

    const setCfg = val => {
        setCfgState(val);
        if (val == null) localStorage.removeItem("cfg");
        else localStorage.setItem("cfg", JSON.stringify(val));
    };

    const setAuth = val => {
        setAuthState(val);
        localStorage.setItem("auth", JSON.stringify(val));
    };

    const table = cfg?.bord;

    const setTable = tableValue => {
        const updatedCfg = { ...cfg, bord: tableValue };
        setCfg(updatedCfg);
    };

    const sid = cfg?.sid;

    useEffect(() => {
        if (!sid) return;

        // Check sessionStorage first
        const saved = sessionStorage.getItem(`theme-${sid}`);
        if (saved) {
            applyTheme(JSON.parse(saved));
        }

        fetchTheme()
            .then(res => {
                if (res.ok && res.theme) {
                    sessionStorage.setItem(`theme-${sid}`, JSON.stringify(res.theme));
                    applyTheme(res.theme);
                }
            })
            .catch(err => console.error("Failed to fetch theme", err));
    }, [sid]);



    if (loading) return null;

    return (
        <AppContext.Provider
            value={{
                cfg,
                sid,
                setCfg,
                getCfg,
                table,
                setTable,
                auth,
                setAuth,
                getAuth,
                init,
                getMenu,
                setMenu,
                unpaid,
                orderids,
                setOrderids
            }}
        >
            {children}
        </AppContext.Provider>
    );
};
